import { PURCHASE_TYPE_MAPPINGS } from "./constants";

export const getButtonText = (purchaseType) => {
  return PURCHASE_TYPE_MAPPINGS?.[purchaseType] || "Select";
};

export const getPurchaseType = (purchaseType) => {
  return Object.keys(PURCHASE_TYPE_MAPPINGS).find(
    (key) => PURCHASE_TYPE_MAPPINGS[key] === purchaseType,
  );
};

export const getEnabledPurchaseOptions = (equipment) => {
  if (!equipment) return [];
  return Object.keys(PURCHASE_TYPE_MAPPINGS).filter((key) => equipment[key]);
};
